import { cn } from '@immo/ui-kit';
import { useTranslations } from '@/i18n/use-translations';
import { HealthLineChart } from './health-line-chart';

type ChartProps = Parameters<typeof HealthLineChart>[0];

type Props = Omit<ChartProps, 'aside'> & {
  readonly value: string | null;
  readonly warning: boolean;
  readonly className?: string;
};

/** One history chart in its bordered card, with the latest reading beside its title (IMM-1450). */
export function HistoryCard({ value, warning, className, ...chart }: Props) {
  const t = useTranslations('pages.admin.fleet.health');

  return (
    <div className={cn('rounded-lg border border-border bg-surface p-4', className)}>
      <HealthLineChart
        {...chart}
        aside={
          <span className={cn('text-base-sm', warning ? 'text-warning-700' : 'text-text-secondary')}>
            {value ?? t('no-data')}
          </span>
        }
      />
    </div>
  );
}
